/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { OFL_PACKING_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { OflPage } from "@/features/processing/components/ofl-page";

export const Route = createFileRoute("/_app/packaging/ofl/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(OFL_PACKING_FORM))
      throw redirect({ to: "/packaging/ofl" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <OflPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
